import { render, staticRenderFns } from "./CourseGrade.vue?vue&type=template&id=2d7fbbe8"
import script from "./CourseGrade.vue?vue&type=script&lang=js"
export * from "./CourseGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports